import React, { useRef, useEffect, useState } from "react";
import { Fireworks } from "fireworks-js";
import './firework.scss'

export default function Firework({ openFirework }) {
  const containerRef = useRef(null);
  const fireworksInstance = useRef(null);

  useEffect(() => {
    if (openFirework && containerRef.current) {
      // Dừng và xóa instance cũ nếu tồn tại
      if (fireworksInstance.current) {
        fireworksInstance.current.stop();
        containerRef.current.innerHTML = "";
        fireworksInstance.current = null;
      }

      // Tạo lại instance mới của Fireworks
      fireworksInstance.current = new Fireworks(containerRef.current, {
        speed: 10,
        rocketsPoint: 50, 
        particles: 800,
        trace: 3,
        delay: { min: 10, max: 20 },
        explosion: 10,
        autoresize: true,
        hue: { min: 0, max: 360 },
        brightness: { min: 50, max: 80, decay: { min: 0.015, max: 0.03 } },
      });

      fireworksInstance.current.start();

      setTimeout(() => {
        if (fireworksInstance.current) {
          fireworksInstance.current.stop();
          containerRef.current.innerHTML = ""; 
          fireworksInstance.current = null;
        }
      }, 5000);
    }
  }, [openFirework]);

  return (
    <div className="App" style={{ textAlign: "center", padding: "20px" }}>
      <div
        ref={containerRef}
        style={{
          position: "fixed",
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          zIndex: 10,
          pointerEvents: "none",
        }}
      ></div>
    </div>
  );
}
